import { render, staticRenderFns } from "./ParamTipoArea.vue?vue&type=template&id=686b08ce"
import script from "./ParamTipoArea.vue?vue&type=script&lang=js"
export * from "./ParamTipoArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports